module.exports = __webpack_public_path__ + "static/media/carrito.5295a9fc.svg";